import { useEffect, useRef } from 'react';
import { useStore } from '../../store/store';
import { useTrackingManager } from '../use-tracking-manager';
import { onVWBasicGenericErrorMessageLoadEvent } from '../../tagging/tagging-helpers';

/**
 * Hook to track when error messages are displayed.
 * Tracks when notificationMessage changes to a non-empty value.
 */
export const useErrorMessageTracking = () => {
  const [state] = useStore();
  const trackingManager = useTrackingManager();
  const previousMessageRef = useRef<string>('');

  const { qsgNavigation, notificationMessage } = state.qsg;

  useEffect(() => {
    // Only track when message changes to a non-empty value
    if (
      !notificationMessage ||
      previousMessageRef.current === notificationMessage
    )
      return;

    previousMessageRef.current = notificationMessage;

    const model = qsgNavigation
      ? {
          modelId: qsgNavigation.modelId,
          modelName: qsgNavigation.modelName,
          modelYear: qsgNavigation.modelYear,
        }
      : undefined;

    if (trackingManager) {
      onVWBasicGenericErrorMessageLoadEvent(
        trackingManager,
        notificationMessage,
        model
      );
    }
  }, [notificationMessage, qsgNavigation, trackingManager]);
};
